module.exports = __webpack_public_path__ + "static/img/logo.ee946a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/com/logo.png
// module id = QS61
// module chunks = 24